import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"filter\"><g fill-rule=\"evenodd\"><path d=\"M7 12.964l2.026-.7V7.92l2.989-3.846V3.033H4v1.003l3 3.89z\" /><path d=\"M0 0v1.02a1 1 0 001 1h1v2.002l3 3.963v7.984l6-2.501V7.985l3-3.963V2.02h1a1 1 0 001-1V0H0zM6.02 8L3 4.023V2.03h10.018v1.993L10 8v4.941l-3.98 1.5V8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id